<template>
    <div class="system-user-container" v-loading="loading">
        <el-row type="flex" justify="end">
						<el-button @click="onAddUser"  icon="el-icon-plus" type="primary">新建用户
						</el-button>
				</el-row>

        <div class="radius-border">
        <el-form :inline="true" :model="formInline" style="display: flex;width: 50%;padding-top:10px;" >
            <el-form-item label="关键字" class="row-first">
                <el-input v-model="formInline.keyWord" placeholder="关键字"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSearchByKeyWord">查询</el-button>
            </el-form-item>
        </el-form>
        <!-- <el-button @click="onAddUser" type="primary" style="margin:0 0 8px 8px">+新建用户</el-button> -->
        </div>
        <div class="radius-border-post" style="margin-top:-13px">
        <!-- <el-table
                :data="ul.slice((currentPage-1)*8,currentPage*8)"
                border
                :header-cell-style="{background:'#eef1f6',color:'#606266'}"
                style="width: 100%;margin-top: 20px;"> -->
        <common-table :data="ul">
            <!-- <el-table-column
                    prop="num"
                    align="center"
                    label="序号"
                    width="50">
            </el-table-column> -->
            <el-table-column
                    prop="userName"
                    align="center"
                    label="用户名">
            </el-table-column>
            <el-table-column
                    prop="name"
                    align="center"
                    label="姓名">
            </el-table-column>
            <el-table-column
                    prop="telNo"
                    align="center"
                    label="电话">
            </el-table-column>
            <el-table-column
                    prop="mail"
                    align="center"
                    label="邮箱">
            </el-table-column>
            <!-- <el-table-column
                    prop="companyName"
                    align="center"
                    label="单位">
            </el-table-column> -->
            <el-table-column
                    prop="isAdmin"
                    width="100"
                    align="center"
                    label="管理员">
                <template slot-scope="scope">
                    <span>{{scope.row.isAdmin?'是':'否'}}</span>
                </template>
            </el-table-column>
            
            <el-table-column
                    prop="roleName"
                    width="100"
                    align="center"
                    label="角色">
            </el-table-column>
            <el-table-column
                    prop="rowTime"
                    align="center"
                    label="创建日期">
            </el-table-column>
            <el-table-column
                    prop="operation"
                    width="130"
                    align="center"
                    label="管理">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click.native.prevent="handleResetPassword(scope.row)" type="text"
                               size="small">重置
                    </el-button>
                    <el-button @click.native.prevent="handleDelete(scope.row)" type="text" size="small">删除
                    </el-button>
                </template>
            </el-table-column>
        </common-table>   
        <!-- </el-table>
        <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="8"
                layout="total, prev, pager, next"
                :total="userList.length">
        </el-pagination> -->
        </div>

        <el-dialog title="编辑用户" :visible.sync="editUserDialogFormVisible">
            <el-form :inline="true" :model="editUserForm">
                <el-form-item label="用户名" label-width="100px">
                    <el-input v-model="editUserForm.userName" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="姓名" label-width="100px">
                    <el-input v-model="editUserForm.name" autocomplete="off"></el-input>
                </el-form-item>

                <el-form-item label="电话" label-width="100px">
                    <el-input v-model="editUserForm.telNo" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="邮箱"  label-width="100px">
                    <el-input v-model="editUserForm.mail" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="单位/角色" label-width="100px">
                    <!-- <el-col :span="24"> -->
                        <el-cascader
                            v-model="value"
                            style="width:400px"
                            :options="companyRoleList"
                            @change="handleCRChange"></el-cascader>
                    <!-- </el-col> -->
                </el-form-item>
                	
					<el-form-item label="是否后台管理员">
								<el-switch
									v-model="editUserForm.isAdmin"
									active-color="#13ce66"
									active-text="是"
  									inactive-text="否"
									inactive-color="#ff4949">
								</el-switch>
					</el-form-item>				
				
					
		    

                <!-- <el-form-item label="单位" label-width="100px">
                    <el-select v-model="editUserForm.companyId" placeholder="请选择">
                        <el-option
                                v-for="item in supplierList"
                                :key="item.companyId"
                                :label="item.companyName"
                                :value="item.companyId">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="角色" label-width="100px">
                    <el-select v-model="editUserForm.roleId" placeholder="请选择">
                        <el-option
                                v-for="item in userSettingRoleList"
                                :key="item.roleId"
                                :label="item.roleName"
                                :value="item.roleId">
                        </el-option>
                    </el-select>
                </el-form-item> -->

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editUserDialogFormVisible = false">取 消</el-button>
                <el-button :loading="editUserDialogConfirmLoading" type="primary" @click="onEditedConfirm">确 定
                </el-button>
            </div>
        </el-dialog>
       
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {generateDepartmentFinalIdArray} from "@/utils/data-generator";
	import {deleteUser,resetPassword} from "@/api/user";
    import {Message} from "element-ui";
    import CommonTable from "@/components/CommonTable";
    import {createIdsFromSever,changeStrtoArray,createMoniTypeIdsFromSever} from "@/views/System/Account/common-manager";

    export default {
        name: "SystemUser",
        components: {CommonTable},
        computed: {
            ...mapGetters(['userList', 'supplierList', 'userSettingRoleList','ul','companyRoleList','stationGroupList'])
        },
        data() {
            return {
                editUserDialogFormVisible: false,
                editUserDialogConfirmLoading: false,
                loading: true,
                formInline: {
                    keyWord: '',
                },

                editUserForm: {
                    userName: '',
                    name: '',
                    telNo: '',
                    mail: '',
                    departmentName: '',
                    moniTypeIds:[],
                    moniTypeIdsStr:'',
                    departmentId: -1,
                    departmentIdArrayForForm: [],
                    isAdmin: false,
 
                    roleName: '',
                    roleId: '',

                },
                currentPage: 1,
                
                value: [],
                // rules: {    
                //   mail: [
                //     { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                //     {
                //       type: 'email',
                //       message: '请输入正确的邮箱地址',
                //       trigger: ['blur', 'change'],
                //     },
                //   ],
                // }
            }
        },

        // watch: {
		// 		async visible(newValue) {					
		// 				if (newValue) {		
        //                 }
        //         }
        // },
        async beforeMount() {
            console.log('beforeMount')
            this.loading = true;
            try {
                await this.$store.dispatch('user/getUserList', this.formInline.keyWord);
                
                
            } catch (e) {
                console.error(e);
            } finally {
                this.loading = false;
            }
        },
        watch: {
            // 'editUserForm.roleId'(newRoleId) {
            //     this.editUserForm.roleName = this.$store.state.user.roleList.find(item => newRoleId === item.roleId)?.roleName ?? '';
            // },
        },
        methods: {

            handleCRChange(value) {
                console.log('change',value);
            },

            onDepartmentListItemChooseChange(newArray) {
								// this.editUserForm.departmentIdArrayForForm = newArray;
                // this.editUserForm.departmentId = newArray[newArray.length - 1];
            },
            onAddUser() {
                this.handleEdit({});
            },
            async handleEdit(item) {
                console.log('item', item);
                // await this.$store.dispatch('user/getUserDepartmentList');
                // await this.$store.dispatch("operate/supplierList");
                // await this.$store.dispatch('user/getUserRoleList');
                await this.$store.dispatch('role/companyRoleList');
                await this.$store.dispatch('user/stationGroupList');
              
                // console.log('stationGroupList',this.stationGroupList)
                // var key=Object.keys(item);
                // var value=Object.values(item);
                console.log('value',item,item.length,item.companyRole);
                // if (item.length>0)
                if (item.companyRole)
                    this.value = JSON.parse('['+item.companyRole+']');
                // console.log('value',item,item.length,this.value,item.companyRole);
                // console.log('companyRoleList', this.companyRoleList);
                this.editUserDialogFormVisible = true;


                this.editUserForm = {...item};

                var pp = item.moniTypeIds;
                if (pp)
					this.editUserForm.moniTypeIds = changeStrtoArray({userIds:pp}).userArray;
                console.log('this.editUserForm.moniTypeIds',this.editUserForm.moniTypeIds)

            },

            async onEditedConfirm() {
              if (!this.editUserForm.userName?.trim()) {
				this.$message.warning('请输入用户名');
				return;
              }
            
                console.log(this.value)
              if (this.value.length!=2){
                  this.$message.warning('请选择单位/角色');
                  return;
              }
            //   if (!this.editUserForm.companyId) {
            //         this.$message.warning('请选择单位');
            //         return;
            //   }

            //   if (!this.editUserForm.roleId) {
            //         this.$message.warning('请选择角色');
            //         return;
            //   }
                this.editUserForm.companyId=this.value[0];
                this.editUserForm.roleId=this.value[1];
                
                this.editUserDialogConfirmLoading = true;                

                if (!this.editUserForm.userId) {
                    this.editUserForm.userId='';
                }

                console.log('this.editUserForm',this.editUserForm);
      

                const {moniTypeIds:idArray2} = this.editUserForm;
					// console.log('const idArray',idArray)
                if (idArray2)
				    this.editUserForm.moniTypeIds = createMoniTypeIdsFromSever({idArray2}).ids;


                try {
                    await this.$store.dispatch('user/setUserModify', {
                        ...this.editUserForm,
                        isAdmin: Number(this.editUserForm.isAdmin),
                    });
                    this.editUserDialogFormVisible = false;
                    Message({message: '保存成功', type: 'success'})
                } catch (e) {
                    Message({message: '保存失败，请重试', type: 'error'})
                    console.error(e);
                } finally {
                    this.editUserDialogConfirmLoading = false;
                }
								await this.onSearchByKeyWord();
			},

            async handleResetPassword(target) {
                // console.log('handleResetPassword', target);
                await this.$confirm('是否确认重置密码', '重置密码', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                });
                try {
                    await resetPassword({uName: target.userName, newPswd: '123456'});
                } catch (e) {
                    this.$message({type: "error", message: '重置失败，请重试'});
                    console.error(e);
                }

                this.$message({type: "success", message: '重置成功'});
            },

            async handleDelete(target) {
               
                await this.$confirm('是否确定删除该用户', '删除用户', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                });
                try {
                    await deleteUser({userId: target.userId, optUserId: this.$store.state.user.userId});
                } catch (e) {
                    this.$message({type: "error", message: '删除失败，请重试'});
                    console.error(e);
                }
                this.$message({type: "success", message: '删除成功'});
								await this.onSearchByKeyWord();
			},
           
            async onSearchByKeyWord() {
                this.loading = true;
                await this.$store.dispatch('user/getUserList', this.formInline.keyWord);
                this.loading = false;
            },
           
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            }
        }
    }
</script>

<style scoped>

</style>
